// extracted by mini-css-extract-plugin
export var acceptance = "TreatyParticipantGraph-module--acceptance--4689b";
export var accession = "TreatyParticipantGraph-module--accession--8da72";
export var container = "TreatyParticipantGraph-module--container--59ce6";
export var item = "TreatyParticipantGraph-module--item--e7c3d";
export var items = "TreatyParticipantGraph-module--items--a998a";
export var none = "TreatyParticipantGraph-module--none--68249";
export var printItem = "TreatyParticipantGraph-module--printItem--01481";
export var printItems = "TreatyParticipantGraph-module--printItems--dc88e";
export var ratification = "TreatyParticipantGraph-module--ratification--e123e";
export var signature = "TreatyParticipantGraph-module--signature--ce983";
export var source = "TreatyParticipantGraph-module--source--52a4d";
export var succession = "TreatyParticipantGraph-module--succession--a47ae";
export var tooltipContent = "TreatyParticipantGraph-module--tooltip-content--e2b92";